import { createIcon } from './factory'
import Icon from './joystick.svg?react'

export const Joystick = createIcon({ regular: Icon, bold: Icon, fill: Icon, duotone: Icon })
